import { getDatasetQuery } from '@gonfalon/rest-api/queries/datasets';
import { useProjectKey } from '@gonfalon/router/useProjectKey';
import { useQuery } from '@tanstack/react-query';

export function useDataset(datasetId: string) {
  const projKey = useProjectKey();

  return useQuery({
    ...getDatasetQuery({ projKey, datasetId }),
    enabled: !!datasetId,
  });
}
